"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUrlsConfiguration = getUrlsConfiguration;
var _cache = require("./internals/cache");
var _fetchConfiguration = require("./internals/fetchConfiguration");
var _loadConfiguration = require("./internals/loadConfiguration");
var _types = require("./types");
var _createConfigurationUrl = require("./utils/createConfigurationUrl");
const CACHE_KEY = 'URLS_CONFIGURATION';
// eslint-disable-next-line max-params -- we allow 4 parameters to keep the function signature similar to other functions
async function getUrlsConfiguration(environment, azureRegionOrTenant, serviceName, options) {
  const configuration = await (0, _loadConfiguration.loadConfiguration)((0, _cache.createCacheKey)(CACHE_KEY, environment, azureRegionOrTenant), async () => (0, _fetchConfiguration.fetchConfiguration)((0, _createConfigurationUrl.createConfigurationUrl)(_types.ConfigurationType.Url, environment, azureRegionOrTenant), options?.configurationManagerOptions), {
    withoutCache: options?.withoutCache ?? false
  });
  return configuration[serviceName];
}
//# sourceMappingURL=getUrlsConfiguration.js.map